import { createCommand } from '../../utils';
import { displayDegradations, moduleName } from '../state';
import { userOrganizationQuery } from '../../authentication/queries';

type Args = {
    display: boolean;
};

export const UpdateDisplayDegradationsCommand = createCommand(
    `${moduleName}/UPDATE_DISPLAY_DEGRADATIONS`,
    async ({ display }: Args, { dispatch, extra, getState }) => {
        const userOrganization = userOrganizationQuery(getState());

        if (userOrganization) {
            await extra.mapViewSettings.updateDisplayDegradationsForOrganization(userOrganization.id, display);
        }

        dispatch(displayDegradations(display));
    },
);
